<div class="container py-5 position-relative" *ngIf="loader" style="min-height: 300px"
  [dir]="this.apiService.currentDirection">
  <div class="loader"></div>
</div>


<!-- <div *ngIf="!loader"> -->


<!------------------------------------------------------------------if isleaf is false ------------------------------------------------------------------------------------------->
<div *ngIf="isLeaf==false">
  <!--------------------------------------------------header--------------------------------------------->
  <div class="position-relative headerBack" id="headerBack" [dir]="this.apiService.currentDirection"
    [style.background-image]="'url(' + category.imageBase64 + ')'"
    style="background-size: 600px;"
    [ngStyle]="{'text-align': apiService.currentDirection === 'rtl'?'right':'left','background-position': apiService.currentDirection==='ltr'? 'right 12vw top': '12vw 0'}">
    <!--    [ngStyle]="{'transform': apiService.currentDirection==='ltr'? 'scale(-1, 1)': null}"-->

    <div class="container" style="min-height: 500px">
      <div class="col-12 col-md-6">

        <div class="">
          <div class="p-3 backLight">
            <img [src]="category.iconImage" class="miniIcon" width="100%" />
            <h1 class="my-4 bold">
              {{this.category.title}}
            </h1>
            <p class="text-justify" [innerHTML]="category.description"></p>
            <a [href]=submitRequestLink target="blank"> <button class="btn btn-primary custom-btn mt-4"
                [disabled]="isActive? false:true">{{'SubmitRequest'|translate}}
              </button></a>

          </div>


        </div>

      </div>
      <div class="col-12 col-md-6">
      </div>

    </div>
  </div>
  <!-------------------------------------------------- slider --------------------------------------------------->
  <div class="pt-5  graySection ">
    <div class="mt-5 pt-3">
      <my-slider [getListData]="this.category.subCategoies" [totalCards]="this.category.subCategoies.length"
        [size]="300"></my-slider>
    </div>

  </div>

  <!-------------------------------------------------- Search --------------------------------------------------->
  <div class="container" [dir]="this.apiService.currentDirection"
    [ngStyle]="{'text-align':apiService.currentDirection==='rtl'?'right':'left'}">
    <h3 class="bold mt-5 pt-5 px-3">{{'LookingForSomethingElse?'|translate}}</h3>
    <div class="my-3 col-12 col-md-7 col-lg-7 text-center pb-5 mb-5">

      <my-search></my-search>
    </div>

  </div>


  <!-------------------------------------------------- skill images --------------------------------------------->


  <div class="container position-relative" [dir]="this.apiService.currentDirection"
    [ngStyle]="{'text-align':apiService.currentDirection==='rtl'?'right':'left'}">
    <h2 class="bold mt-3 pt-5 marginSm">{{'SomeOfAlobodoServices'|translate}} {{category.title}}</h2>
    <div class="pt-5" *ngFor="let item of category.subCategoies; let i =index">
      <div class="mt-5 pt-3">
        <h4 class="col-12 mt-3 bold marginSm">{{item.title}}</h4>
        <tag-slider [getListData]="this.category.subCategoies[i].tags" [linkRequest]="tagRequestLink" [size]="200" 
          [getActive]="this.category.subCategoies[i].isActive" [totalCards]="this.category.subCategoies[i].tags.length"></tag-slider>
      </div>
    </div>
    
  </div>
  
  <!-----------------------------------------------------------skill end------------------------------------------------------------>
<div class="container graySection" [dir]="this.apiService.currentDirection" style="min-height: 200px;"
    [ngStyle]="{'text-align':apiService.currentDirection==='rtl'?'right':'left'}">

    <h6><a class="bold position-absolute" style="text-decoration: none; margin: 50px auto;"
       [routerLink]="['/services/'+category.id]">{{'SeeAll'|translate}}</a></h6>
  </div>
  
</div>


  
<!------------------------------------------------------------------------------------------------------------------------------------if isleaf is true, for search result from home page ------------------------------------------------------------------------------------------->
<div *ngIf="isLeaf==true" [dir]="this.apiService.currentDirection"
  [ngStyle]="{'text-align': apiService.currentDirection === 'rtl'?'right':'left'}">
  <!-------------------------------------header---------------------------------------->
  <div class="container py-5 position-relative">

    <div class="row" style="min-height: 500px">
      <div class="col-12 col-md-6 position-relative">
        <div class="pt-5 ">
          <img [src]="category.iconImage" class="miniIcon" width="100%" />
          <h5 class="mt-2 categoryTitle bold" style="cursor:pointer" (click)="getData()">{{category.upCategory.title}}
          </h5>
          <h1 class="my-4 bold">
            {{this.category.title}}
          </h1>
          <p class="text-justify" *ngIf="category.description"
            [ngStyle]="{'padding':apiService.currentDirection === 'rtl' ? '0 0 0 20px':'0 20px 0 0'}"
            [innerHTML]="category.description"></p>
          <p class="text-justify" *ngIf="!category.description"
            [ngStyle]="{'padding':apiService.currentDirection === 'rtl' ? '0 0 0 20px':'0 20px 0 0'}"
            [innerHTML]="category.upCategory.description"></p>

          <!--            <button class="btn btn-primary custom-btn mt-4"><a [href]="['https://web.alobodo.com/services?id='+category.id+'&title='+category.title+'&isLeaf=true']"-->
          <a [href]=submitRequestLink target="blank"> <button [disabled]="isActive? false:true"
              class="btn btn-primary custom-btn mt-4">{{'SubmitRequest'|translate}}
            </button></a>
        </div>
      </div>
      <div class="col-12 col-md-6 banner position-relative">
        <div class="banner position-absolute px-2" style="top: 50%;left:50%; transform: translate(-50%, -50%)">
          <img [src]="category.imageBase64" width="100%" [alt]="category.imageAlt" />
        </div>


      </div>

    </div>
  </div>

  <!-------------------------------content------------------------------->

    <tag-slider [getListData]="this.category.skills" [linkRequest]="tagRequestLink" [size]="200"
        [getActive]="this.category.isActive" [totalCards]="this.category.skills.length"></tag-slider>

</div>
<!-- </div> -->
